import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function Eyebrow({
  children,
  tone = 'light'
}: EyebrowProps) {
  const toneClasses = tone === 'dark' ? 'border-ivory/30 bg-ivory/10 text-ivory' : 'border-sage/40 bg-white/70 text-sage-deep';
  return <span className={`inline-block rounded-full border px-3 py-1 font-sans text-[10px] md:text-[11px] font-semibold uppercase tracking-[0.12em] ${toneClasses}`} style={{
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "12px",
    paddingRight: "12px",
    width: "223px",
    height: "34px"
  }} data-id="element-56" data-mp="1gtw79g9nylc0">
      {children}
    </span>;
}